import { Component, Ref } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import dayjs from 'dayjs'
import './index.less'
import { ProductRegisterServiceProxy } from '@/service-proxies/app-v2/console.service-proxies'


import {
  HubServiceProxy
} from '@/service-proxies/app-v2/iot-console.service-proxies'

import { ProductBatchServiceProxy, GatewayServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import CurdForm from '@/components/BaseCurd/form'
import { getUserInfo } from '@/utils/auth'
import {hardwareType} from "@/views/console/gateway-list/components/data";

const systemService = new MasterlinkTenantServiceProxy()
const service = new ProductRegisterServiceProxy()

const pbsp = new ProductBatchServiceProxy()
const gsp = new GatewayServiceProxy()
const hubServ = new HubServiceProxy()

enum Codes {
  硬件网关 = 1,
  软件网关 = 3,
}



type test = [];

@Component({
  CurdForm
})
export default class Batch extends Template {
  @Ref() readonly form: CurdForm

  name = 'batch'
  templateModalClass = 'batch-modal2'
  scroll = {
    x: 1600
  }
  defaultHubId = ''

  options = {
    retrieve: async function(current: any, filter: any, size: any) {
      // const tenantId = getUserInfo().tenant_id
      let params: any = { current, filter, size, ascs: '', descs: '', tenantId: this.selectTenant }
      return await pbsp.pageProductBatch(params)
    },
    create: (data) => {
      return pbsp.addProductBatch(data)
    },
    update: (data) => {
      return pbsp.updateProductBatch(data)
    },
    delete: pbsp.deleteProductBatch.bind(pbsp)
  }

  get lang() {
    return {
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      create: this.$t('page_batch_management_create'),
      delete: this.$t('delete')
    }
  }

  acl = {
    create: 'page_iot_batch_management_create',
    update: 'page_iot_batch_management_update',
    delete: 'page_iot_batch_management_delete',
    register: 'page_iot_batch_management_register'
  }
  showRegisterDialog = false
  registerdataValue = {}
  hidden = ['delete']
  tenants = []
  selectTenant = undefined

  async mounted() {
    const {
      data: { records }
    } = await systemService.getTenants(undefined, 1, -1, undefined, undefined)

    this.tenants = records
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    this.loading = true
    if (reload) current = 1
    const fetchFn = this.options.retrieve.bind(this)
    const { items, totalCount: t } = await fetchFn(
      current,
      keyWords,
      size
    )
    this.loading = false
    // this.dataSource = items

    let dataLength = items.length;
      let copy = JSON.parse(JSON.stringify(items));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }  

      this.dataSource = JSON.parse(JSON.stringify(copy));

    this.filters.total = Number(t)
  }

  handleChange() {
    this.getData()
  }

  filterOption(value, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(value.toLowerCase()) >= 0
    )
  }

  get columns() {
    return [
      {
        title: this.$t('page_batch_management_action'),
        key: 'action',
        // fixed: "left",
        width: 200,
        ellipsis: true,
        customRender: (row,record) => {
          return (
            record.id &&
            <div style="">
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation()
                  this.openEditWindow(row)
                }}
              >
                {this.$t('edit')}
              </a>
              <a-divider type="vertical"/>
              <a
                type="link"
                disabled={!this.getAcl(this.acl.register)}
                onClick={(e) => {
                  e.stopPropagation()
                  this.openRegisterDialog(row)
                }}
              >
                {this.$t('page_batch_management_register_equipment')}
              </a>
              <a-divider type="vertical"/>
              <a-popconfirm
                disabled={!this.getAcl(this.acl.delete)}
                title={this.$t('page_resource_pool_confirm_delete')}
                onConfirm={() => this.deleteSingleData(row.batchNo)}
                okText={this.$t('yes')}
                cancelText={this.$t('no')}
              >
                <a
                  type="link"
                  disabled={!this.getAcl(this.acl.delete)}
                  onClick={(e) => e.stopPropagation()}
                  class="del-color"
                >
                  {this.$t('delete')}
                </a>
              </a-popconfirm>
            </div>
          )
        }
      },
      {
        title: this.$t('page_batch_management_no'),
        dataIndex: 'batchNo',
        key: 'batchNo',
        width: 98,
        ellipsis: true
      },
      {
        title: this.$t('page_batch_management_description'),
        dataIndex: 'remark',
        key: 'remark',
        width: 205,
        ellipsis: true,
        customRender: (text) => (
          <ellipsis length={20} tooltip>
            {text}
          </ellipsis>
        )
      },
      {
        title: this.$t('page_batch_management_type'),
        dataIndex: 'productType',
        key: 'productType',
        width: 123,
        ellipsis: true,
        customRender: (text) => Codes[text]
      },
      {
        title: '硬件类型',
        dataIndex: 'hardwareType',
        key: 'hardwareType',
        width: 123,
        ellipsis: true,
        customRender: (value) => {
          let obj = hardwareType.find(item => item.value === value)
          if (obj){
            return  obj.label
          }else {
            return ''
          }
        },
      },
      {
        title: this.$t('page_batch_management_name'),
        dataIndex: 'productName',
        key: 'productName',
        width: 123,
        ellipsis: true
      },
      {
        title: this.$t('page_batch_management_code'),
        dataIndex: 'productCode',
        key: 'productCode',
        width: 123,
        ellipsis: true
      },
      {
        title: this.$t('page_batch_management_number'),
        dataIndex: 'totalQuantity',
        key: 'totalQuantity',
        width: 123,
        ellipsis: true
      },
      {
        title: this.$t('page_batch_management_auth_apps'),
        dataIndex: 'allowConnectionCount',
        key: 'allowConnectionCount',
        width: 156,
        ellipsis: true
      },
      {
        title: this.$t('page_batch_management_iothub'),
        dataIndex: 'hubGatewayPort',
        key: 'hubGatewayPort',
        width: 200,
        ellipsis: true
        // customRender: (row) => `${row.iothubGatewayPort}`,
      },
      /*{
        title: this.$t("page_batch_management_key"),
        dataIndex: "activateKey",
        key: "activateKey",
        width: 136,
        ellipsis: true,
      },*/
      {
        title: this.$t('page_batch_management_counder'),
        dataIndex: 'createUserName',
        key: 'createUserName',
        width: 145,
        ellipsis: true
      },
      {
        title: this.$t('page_batch_management_createtime'),
        dataIndex: 'createTime',
        key: 'createTime',
        width: 203,
        ellipsis: true,
        customRender: (time,record) => {
          if(record.id) {
            return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      }
    ]
  }


  get schema() {
    return {
      productType: {
        label: this.$t('page_batch_management_type'),
        type: 'radio',
        props: {
          placeholder: this.$t('page_batch_management_type_tips')
        },
        options: [
          {
            label: this.$t('page_batch_management_Hardware'),
            value: 1
          },
          {
            label: this.$t('page_batch_management_Software'),
            value: 3
          }
        ],
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_type_tips')
          }
        ],
        disabled: true
      },
      tenantId: {
        label: this.$t('page_batch_management_tenant'),
        type: 'select',
        props: {
          placeholder: this.$t('page_batch_management_tenant_tips'),
          showSearch: true,
          filterOption: this.filterOption
        },
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_tenant_tips')
          }
        ],
        disabled: true,
        options: async () => {
          const { data } = await systemService.getTenants(
            undefined,
            1,
            -1,
            undefined,
            undefined
          )
          const { records } = data
          return records.map((r) => ({
            label: r.tenantName,
            value: r.tenantId
          }))
        }
      },
      allowConnectionCount: {
        label: this.$t('page_batch_management_auth_apps'),
        type: 'inputNumber',
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_auth_apps_tips')
          }
        ],
        props: {
          min: 1,
          max: 60000
        },
        disabled: true,
        defaultValue: 100
      },
      hardwareType: {
        label: '硬件类型',
        type: 'select',
        props: {
          maxLength: 32,
          showSearch: true,
          placeholder: '请选择硬件类型',
        },
        rules : [
          {

            required: false,
            message:'请选择硬件类型',
          }
        ],
        options: async () => {
          return hardwareType
        },
        defaultValue : 's2',
        disabled: true,
      },
      productName: {
        label: this.$t('page_batch_management_name'),
        type: 'input',
        props: {
          maxLength: 32,
          placeholder: this.$t('page_batch_management_name_tips')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_name_tips')
          }
        ],
        disabled: true
      },
      productCode: {
        label: this.$t('page_batch_management_code'),
        type: 'input',
        props: {
          maxLength: 32,
          placeholder: this.$t('page_batch_management_code_tips')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_code_tips')
          }
        ],
        disabled: true
      },
      hubId: {
        label: this.$t('page_batch_management_iothub'),
        type: 'select',
        props: {
          placeholder: this.$t('page_batch_management_iothub_tips')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_iothub_tips')
          }
        ],
        options: async () => {
          const { items } = await hubServ.getHubList()
          let temp = items.map((r) => ({
            label: `${r.gatewayPort}`,
            value: r.id
          }))
          this.defaultHubId = temp.length > 0 ? temp[0].value : undefined
          return temp
        },
        disabled: true,
        defaultValue: this.defaultHubId
      },
      totalQuantity: {
        label: this.$t('page_batch_management_number'),
        type: 'inputNumber',
        props: {
          min: 1,
          max: 999999999
        },
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_number_tips')
          }
        ],
        disabled: true
      },
      remark: {
        label: this.$t('page_batch_management_description'),
        type: 'textarea',
        props: {
          placeholder: this.$t('page_batch_management_description_tips'),
          maxLength: 255
        }
      }
    }
  }

  get registerSchema() {
    return {
      batchNo: {
        label: this.$t('page_batch_management_register_batch'),
        type: 'input',
        disabled: true,
        props: {
          placeholder: this.$t('page_batch_management_register_batch_tips')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_register_batch_tips')
          }
        ]
      },
      registerCount: {
        label: this.$t('page_batch_management_activation_number'),
        type: 'inputNumber',
        props: {
          min: 1,
          max: 999999999
        },
        defaultValue: 1,
        rules: [
          {
            required: true,
            message: this.$t('page_batch_management_activation_number_tips')
          }
        ]
      },
      name: {
        label: this.$t('remark'),
        type: 'textarea',
        props: {
          placeholder: this.$t('remark_tips'),
          maxLength: 255
        }
      }
    }
  }

  render() {
    const slot = (
      <div style="display: flex;align-items:center">
        {getUserInfo().tenant_id === '000000' ?
          (<div style="display: flex;align-items:center">
            <span style="width:40px;font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">{this.$t('page_tenant')}:</span>
            <a-select
              placeholder={this.$t('page_tenant')}
              style="width:250px;margin-right:12px"
              allowClear
              v-model={this.selectTenant}
              onChange={this.handleChange}
              showSearch={true}
              filterOption={this.filterOption}
            >
              {this.tenants.map((item) => {
                return (
                  <a-select-option key={item.id} value={item.tenantId}>
                    {item.tenantName}
                  </a-select-option>
                )
              })}
            </a-select>
          </div>) : ''}

        <span style="width:60px;font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">{this.$t('keyword')}:</span>
      </div>
    )

    return (
      <blank-view class="batch-wrapper">
        {this.renderHeader(slot)}
        <div style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
        </div>
        <a-modal
          class="batch-modal"
          onCancel={() => (this.showRegisterDialog = false)}
          title={this.$t('page_batch_management_register_equipment')}
          visible={this.showRegisterDialog}
          destroyOnClose={true}
          maskClosable={false}
        >
          <div slot="footer">
            <a-button
              style="margin-right:8px"
              onClick={() => (this.showRegisterDialog = false)}
            >
              {this.$t('cancel')}
            </a-button>
            <a-button type="primary" onClick={this.registerData}>
              {this.$t('save')}
            </a-button>
          </div>
          <CurdForm
            acl={{
              save: this.acl.register
            }}
            ref="form"
            type="edit"
            schema={this.registerSchema}
            defaultValue={this.registerdataValue}
            footer={false}
          />
        </a-modal>
      </blank-view>
    )
  }

  openRegisterDialog(row) {
    this.registerdataValue = row
    this.showRegisterDialog = true
  }

  // 登记网关
  async registerData() {
    const data: any = await this.form.manualSubmit()
    const { registerCount, batchNo, name } = data
    let params: any = {
      registerCount, batchNo, name
    }
    await gsp.registerGateway(params)
    this.$message.success(this.$t('page_docdirectory_create_success'))
    this.showRegisterDialog = false
  }

  async deleteSingleData(data) {
    const fetchFn = this.options.delete

    const { current } = this.filters
    const restDataLength = this.dataSource.length - 1

    await fetchFn(data)
    this.$message.success(this.$t('page_user_management_delete_succeeded'))
    await this.getData(
      !restDataLength ? (current - 1 ? current - 1 : current) : current
    )
  }
}
